
import { computed, defineComponent } from 'vue';
export default defineComponent({
  name: 'BalToggle',
  inheritAttrs: false,
  emits: ['update:modelValue', 'toggle'],
  props: {
    name: { type: String, required: true },
    modelValue: { type: Boolean, default: false },
    label: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    color: {
      type: String,
      default: 'green',
      validator: (val: string): boolean => ['green'].includes(val)
    },
    changeType: {
      type: String,
      default: ''
    }
  },
  setup(props, { emit }) {
    const selectCls = computed(() => {
      if (props.changeType === 'list') {
        return 'bal-toggle-select-checkbox';
      }
      return 'bal-toggle-checkbox';
    });
    const selectTrackCls = computed(() => {
      if (props.changeType === 'list') {
        return 'bal-toggle-select-track';
      } else if (props.changeType) {
        return 'bal-toggle-change-track';
      }
      return 'bal-toggle-track';
    });
    /**
     * METHODS
     */
    function onClick(event) {
      if (!props.disabled) {
        emit('update:modelValue', event.target.checked);
        emit('toggle', event.target.checked);
      }
    }
    return {
      // methods
      onClick,
      selectCls,
      selectTrackCls
    };
  }
});
